import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { first, of, tap } from 'rxjs';

import { EchoInstanceService } from '../../services';

export const echoInstanceResolver: ResolveFn<boolean> = (route, state) => {
  const router: Router = inject(Router);
  const echoInstanceService: EchoInstanceService = inject(EchoInstanceService);
  const extrasState = router.currentNavigation()?.extras.state;
  const echoInstanceId = route.paramMap.get('echoInstanceId');
  const echoInstance = extrasState?.['echoInstance'];

  if (echoInstance && echoInstance.id === echoInstanceId) {
    echoInstanceService.setCurrentEchoInstance(echoInstance);
    return of(echoInstance);
  }

  if (echoInstanceId) {
    return echoInstanceService.getEchoInstance(echoInstanceId).pipe(
      first(),
      tap((echoInstance) => {
        if (echoInstance) {
          echoInstanceService.setCurrentEchoInstance(echoInstance);
        }
      })
    );
  }

  return of(undefined);
};
